<template>
    <div class="fullText">
        <annTab :type="2"></annTab>
        <form name="fullForm">
            <ul class="formList">
                <li>
                    <span>PMID:</span>
                    <input name="pmid" v-model="pmid" placeholder="填写PMID进行全文申请" />
                </li>
                <li>
                    <span>DOI:</span>
                    <input name="doi" v-model="doi" placeholder="填写DOI进行全文申请" />
                </li>
                <li>
                    <span>标题:</span>
                    <input name="title" v-model="title" placeholder="填写标题进行全文申请" />
                </li>
                <li>
                    <p class="lastRow">其它:</p>
                    <!-- <input placeholder="上传附件图片" /> -->
                    <van-uploader class="upload" v-model="fileList" :after-read="afterRead" :before-read="beforeRead" :max-count="1" />
                    <textarea name="other" v-model="other" placeholder="上传图片转化或填写文字,点击确定进行全文申请."></textarea>
                </li>
            </ul>
        </form>
        <button @click="fullText" class="subBtn">提交</button>
    </div>
</template>
<script>
import { Toast } from "vant";
import annTab from "../../components/annTab";
export default {
    name: "fullTextApplication",
    data() {
        return {
            pmid: "",
            doi: "",
            title: "",
            other: "",
            fileList: []
        };
    },
    components: {
        annTab
    },
    mounted () {
        this.$store.dispatch("actionsHead", { type: true, title: "智能客服", iconType: false });
    },
    methods: {
        fullText() {
            var url = {
                pmid: this.pmid,
                doi: this.doi,
                title: this.title,
                other: this.other
            };
            if (this.pmid == "" && this.doi == "" && this.title == "" && this.other == "") {
                Toast("请最少输入一项内容");
                return false;
            }
            if (isNaN(this.pmid)) {
                Toast("PMID 格式不正确");
                return false;
            }
            this.$router.push({ name: "fullTextList", params: { params: url } });
        },
        beforeRead(file) {
            //上传前
            //上传之前校验
            if (file.type !== "image/jpeg" && file.type !== "image/png") {
                Toast("只允许上传jpg/png格式的图片!");
                return false;
            }
            return true;
        },
        afterRead(file) {
            //上传后
            var formData = new FormData();
            formData.append("file", file.file);
            // file.status = "uploading";
            // file.message = "上传中...";
            this.$post("https://customer.yuntsg.com/ft/ocr", formData).then((res) => {
                if (res.code == 0) {
                    if (res.data.flag == 1) {
                        this.other = res.data.text;
                    }
                }
            });
        }
    }
};
</script>
<style lang="less">
.fullText {
    background-color: #ffffff;
    color: #2f2f2f;
    font-size: 0.9rem;
    .formList {
        padding: 1rem;
        li:not(:last-child) {
            border-bottom: 1px solid #eeeeee;
            color: #474747;
            height: 3rem;
            padding-top: 0.9rem;
            overflow: hidden;
            span {
                width: 15%;
                display: inline-block;
            }
            input {
                width: 85%;
                outline: none;
                border: none;
            }
        }
        li:last-child {
            border-bottom: none;
            margin-bottom: 3rem;
            .lastRow {
                margin-top: 0.9rem;
            }
            .upload {
                margin: 1rem 0rem;
                .van-uploader__upload {
                    border: 1px dashed #cccc;
                }
            }
            textarea {
                width: 100%;
                line-height: 1.5rem;
                color: #666666;
                background-color: #f8f8f8;
                height: 10rem;
                padding: 0.7rem;
                border: none;
                resize: none;
            }
        }
    }
    .subBtn {
        background-color: #0788e6;
        color: #ffffff;
        width: 90%;
        margin-left: 5%;
        height: 2.5rem;
        line-height: 2.5rem;
        border: none;
        border-radius: 0.3rem;
    }
}
</style>
